export default "__VITE_ASSET__BAcsiLuj__"